import { Notification } from '../../../../../models/Notification'
import { StylesScene } from '../../../../../models/Story'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserAddTaskStyles = {
    [key: string]: StylesScene
}

const UserAddTaskStyles: TUserAddTaskStyles = {
    'Group': {
        groupTitleCollection: {
            container: {
                position: 'absolute',
                top: 300,
                left: 131,
                background: '#fff',
                padding: '10px 16px 12px',
                borderRadius: 4,
                zIndex: 2,
            },
            text: {
                fontFamily: 'Roboto Slab',
                fontSize: 20,
                fontWeight: 'bold',
                color: '#000',
            }
        },
        groupImg: {
            container: {
                position: 'absolute',
                zIndex: 1,
                top: 203,
                left: 148,
                boxSizig: 'border-box',
                width: 280,
                height: 231
            }
        },
        docTitle: {
            container: {
                top: 407,
                left: 29,
                position: 'absolute',
                padding: '12px 13px 10px 16px',
                backgroundColor: '#131313',
                width: 279,
                maxHeight: 79,
                minHeight: 51,
                zIndex: 1,
                textAlign: 'center'
            },
            text: {
                textTransform: 'uppercase',
                fontSize: 28,
                fornWeight: 500,
                color: '#fff',
                height: 1.14,
                letterSpacing: 2.33,
                textAlign: 'center'
            }
        },
        mainImg: {
            container: {
                width: 385,
                height: 217,
                position: 'absolute',
                bottom: 79,
                left: 24,
            }
        },
        addTaskStatic: {
            container: {
                position: 'absolute',
                bottom: 265,
                right: 19,
                borderRadius: 2,
                zIndex: 2,
                backgroundColor: '#fff',
                padding: '9px 2px 13px',
                transform: 'rotate(8deg)'
            },
            text: {
                fontSize: 40,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.2,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#131313',
            }
        },
    },
    'Public': {
        addTaskStatic: {
            container: {
                position: 'absolute',
                bottom: 232,
                left: 11,
                borderRadius: 2,
                zIndex: 2,
                backgroundColor: '#fff',
                padding: '8px 13px 4px 18px',
                transform: 'rotate(8deg)'
            },
            text: {
                fontSize: 36,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.33,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#131414',
                textShadow: '2px 2px 2px rgb(150 150 150)',
            }
        },
        mainImg: {
            container: {
                width: 414,
                height: 357,
                position: 'absolute',
                top: 188,
                left: 32,
            }
        },
        docTitle: {
            container: {
                bottom: 271,
                right: 12,
                position: 'absolute',
                transform: 'rotate(-8deg)',
                padding: '12px 13px 10px 16px',
                backgroundColor: '#131313',
                width: 279,
                maxHeight: 79,
                minHeight: 51,
                overflow: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1,
            },
            text: {
                textTransform: 'uppercase',
                fontSize: 28,
                fornWeight: 500,
                color: '#fff',
                lineHeight: 1.14,
                letterSpacing: 2.33,
            }
        },
    }
}

export const getUserAddTaskBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)[notif.groupType], UserAddTaskStyles[notif.groupType]]
}